import { switchMap, catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { of, from } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { StripeUserAccountForm } from '../../../modules/profile/containers/stripe/models/stripe-user-account-form';
import { StripeBankAccountForm } from './../../../modules/profile/containers/stripe/models/stripe-bank-account-form';

declare var Stripe: any;
const stripe = Stripe(environment.stripe.key);

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  constructor(
    private fun: AngularFireFunctions
  ) { }

  /**
   * TODO-jumangitjs
   * add enhancement to save stripe account here
   * update stripe account on stripe account updates
   */

  getExternalBankAccount(stripe_account_ID: string) {
    return !!stripe_account_ID && stripe_account_ID.trim()
      ? this.fun.httpsCallable('getStripeAccount')({
        accountId: stripe_account_ID
      })
      : of(null);
  }

  addExternalBankAccount(
    // bankToken: string, 
    bankAccountForm: StripeBankAccountForm
  ) {
    return from(stripe.createToken('bank_account', {
      ...bankAccountForm
    }))
      .pipe(
        catchError(error =>
          of({
            message: 'unable to add bank account',
            error
          })
        ),
        switchMap((tokenResult: any) =>
          tokenResult && !tokenResult.error
            ? this.fun.httpsCallable('addExternalBank')
              ({ bank_token: tokenResult.token.id })
              .pipe(
                catchError(error =>
                  of({
                    message: 'unable to add bank account',
                    error
                  })
                ),
                map(result => ({
                  message: 'bank successfully added',
                  data: result
                }))
              )
            : of({
              message: 'unable to add bank account',
              error: tokenResult.error
            })
        )
      );
  }

  updateStripePayoutAccountDetails(
    stripeId: string,
    userAccountForm: StripeUserAccountForm,
    idProvided = false
  ) {
    let result = of(idProvided).pipe(
      switchMap(hasIdFlag => {
        return hasIdFlag
          ? of(hasIdFlag)
          : stripe.createToken('pii', {
            personal_id_number: userAccountForm.p_id
          })
      }),
      catchError(error =>
        of({
          message: 'unable to create customer',
          error
        })
      ),
      switchMap((result: any) => {
        return result && !result.error ?
          this.fun.httpsCallable('updateAccount')
            ({
              stripe_account_ID: stripeId,
              ...userAccountForm
            })
            .pipe(
              catchError(error =>
                of({
                  message: 'unable to update stripe user account details',
                  error
                })
              ),
              map(result => ({
                message: 'successfully updated user details',
                data: result
              }))
            )
          : of({
            message: 'unable to update stripe user account details',
            error: result.error
          })
      }
      ),
      catchError(error =>
        of({
          message: 'unable to update stripe user account details',
          error
        })
      )
    );

    return result;
  }

  deleteExternalBankAccount(id: string) {
    return this.fun.httpsCallable('deleteExternalBank')({
      accountId: id
    });
  }

  setBankAccountAsDefaultForCurrency(id: string) {
    return this.fun.httpsCallable('setDefaultExternalBank')({
      accountId: id
    });
  }

  // formatUserAccountForm(userAccountForm: StripeUserAccountForm) {
  //   return {
  //     ...userAccountForm,
  //     id_provided: undefined
  //   };
  // }

  accountHasNotAcceptedTerms(stripeAccountData) {
    return !stripeAccountData?.tos_acceptance
      || !stripeAccountData?.tos_acceptance?.date
      || !stripeAccountData?.tos_acceptance?.ip;
  }

}
